<template>
  <!--b-container 
    class="section text-light" 
    :class="content.bgClass"
    fluid
  -->
  <b-container 
    class="section bg-neon-blue-grad" 
    fluid
  >
    <b-row class="section p-5">
      <b-col class="m-auto">
        <div class="d-flex justify-content-center pb-4">
          <!--h1>{{ content.header }}</h1-->
          <h1>Start using TrinPod&trade;</h1>
        </div>
        <div class="d-flex justify-content-center pb-4">
          <b-button 
            variant="orange"
            size="lg"
            href="https://trinapp.com"
          >
            <h4 class="mb-0">Get Started</h4>
          </b-button>
        </div>
        <div class="d-flex justify-content-center">
          <p>No Credit Card is collected for your Forever Free Plan</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "CallToAction",
    props: {
      content: Object
    }
  }
  </script>